/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * UpSmith Dev API
 * OpenAPI spec version: 1.0.0
 */

export type BoostPointTransactionSource =
  (typeof BoostPointTransactionSource)[keyof typeof BoostPointTransactionSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BoostPointTransactionSource = {
  app_spot_award: "app_spot_award",
  erp_automation_all: "erp_automation_all",
} as const;
